import {useEffect} from "react";

export default function useFlip(events, fn) {
    useEffect(() => {
        if (!events) return;
        events.addEventListener('flip', fn);
        return () => events.removeEventListener('flip', fn);
    }, [events]);
}
